import { FORM_ONBOARDING_REGISTER } from 'constants/forms'
import { mergeMap, take, switchMap } from 'rxjs/operators'
import { byType } from 'rxOperators/byType'
import { FORM_SUBMITTED_SUCCESSFULLY } from 'actions/formActions'
import { EMPTY, merge, of } from 'rxjs'
import { killAllFloatingPanesActionCreator, MODIFY_FLOATING_PANE } from 'actions/floatingPanesActions'
import { AdvisorMeetingActions } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { EpicRefined } from 'interfaces/middleware'
import FormActions from 'actions/formActions'
import FloatingPaneAction from 'actions/floatingPanesActions'
import { PushAction, pushActionCreator } from 'actions/navigationActions'
import { CREDIT_CARD_PANE } from 'components/features/creditCard/creditCardStore/floatingPane'


export const signupEpic: EpicRefined<FormActions | FloatingPaneAction | AdvisorMeetingActions | PushAction> = (action$) => action$.pipe(
  byType(MODIFY_FLOATING_PANE),
  mergeMap(({ payload }) => {
    if (payload.type !== CREDIT_CARD_PANE || payload.mode !== 'signup') {
      return EMPTY
    }
    return of(payload)
  }),
  switchMap(() => action$.pipe(
    byType(FORM_SUBMITTED_SUCCESSFULLY),
    mergeMap(({ payload }) => {
      if (payload.formName !== FORM_ONBOARDING_REGISTER || payload.formValues.form_mode !== 'credit-card') {
        return EMPTY
      }
      return of(payload)
    }),
    take(1),
    mergeMap(() => merge(
      of(pushActionCreator('/dashboard')),
      of(killAllFloatingPanesActionCreator()),
    ))
  )),
)
